import useNamespace from '@/composables/useNamespace'
import useReducer from '@/composables/useReducer'
import { onScopeDispose } from 'vue'

const DEFAULT_NAMESPACE = Symbol('useReducedState composable default namespace')

/**
 * Reduce provided states in a computed that is true if any of the provided states is true
 * @param {import('vue').Ref<Boolean>} [state] - State ti reduce
 * @param {Symbol|String} [namespace] - Namespace in which the state should be reduced
 * @returns {import('vue').ComputedRef<Boolean>} True if any of the provided states is true
 */
function useReducedState(state, namespace = DEFAULT_NAMESPACE) {
  // First call useReducer in the provided namespace
  const { add, reduced } = useNamespace(namespace, useReducer)((prev, current) => (
    // State is true if any of the provided states is true
    prev || current
  ))

  // If a state was provided
  if (state) {
    // Add the state to the reduced state
    const remove = add(state)
    // Automatically remove the state from the reduced state when scope is disposed
    onScopeDispose(remove)
  }

  return reduced
}

export default useReducedState
